import { Link } from "react-router-dom";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { APP_DEFAULT_PATH } from "config";
import error from "assets/images/maintenance/notFoundData.png";
// import error from "assets/images/maintenance/notFound.jpeg";
// import error4041 from "assets/gif/404NotFound.gif";
const Error404 = ({ headingMain, subHeading, isMainUrl = false }) => {
  return (
    <>
      <Grid
        container
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          p: 0,
          m: 0,
        }}
      >
        {/* IMAGE */}
        <Box
          sx={{
            width: { xs: 200, sm: 380, md: 450 },
            height: "auto",
            marginTop: -50,
          }}
        >
          <img
            src={error}
            alt="error 404"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* BUTTON */}
        <Button
          component={Link}
          to={isMainUrl ? `/` : APP_DEFAULT_PATH}
          variant="contained"
        >
          Back To Home
        </Button>
      </Grid>
    </>
  );
};

export default Error404;
